<template>
    <div>
      <div class="div1">
        <img :src="headImageUrl" class="touxiang"/>
        <span class="span1">{{nickname}}</span>
        <img class="shouji" src="../assets/shouji.png" width="6%" height="3.5%"/>
        <span class="number">{{phone}}</span>
        <!--<img class="xiugai" src="../assets/dgh.png" width="4.5%" height="3%" @click="updatePhone()"/>-->
      </div>
      <div style="background-color: gainsboro; height: 1px;"></div>
      <div class="dhciv" @click="jiaoFei()">
        <img class="tishi"  src="../assets/1.3.png" width="7%" height="48%"/>
        <span class="daohang">我的缴费</span>
        <img class="jiantou" src="../assets/you.png" width="6%" height="38%"/>
      </div>
      <div style="background-color: gainsboro; height: 1px;"></div>
      <div class="dhciv" @click="fangChan()">
        <img class="tishi" src="../assets/1.2.png" width="7%" height="48%"/>
        <span class="daohang">我的房产</span>
        <img class="jiantou" src="../assets/you.png" width="6%" height="38%"/>
      </div>
      <div style="background-color: gainsboro; height: 1px;"></div>
      <div class="dhciv" @click="updatePhone()">
        <img class="tishi" src="../assets/sjh.png" width="7%" height="48%"/>
        <span class="daohang">修改手机</span>
        <img class="jiantou" src="../assets/you.png" width="6%" height="38%"/>
      </div>
      <div style="background-color: gainsboro; height: 1px;"></div>
      <div class="dhciv" @click="xx()">
        <img  class="tishi" src="../assets/1.1.png" width="7%" height="48%"/>
        <span class="daohang">模板消息</span>
        <img class="jiantou" src="../assets/you.png" width="6%" height="38%"/>
      </div>
      <!--<div style="background-color: gainsboro; height: 1px;"></div>-->
      <!--<div class="dhciv" @click="aa()">-->
        <!--<img class="tishi" src="../assets/1.5.png" width="8%" height="48%"/>-->
        <!--<span class="daohang">异常测试</span>-->
        <!--<img class="jiantou" src="../assets/you.png" width="6%" height="38%"/>-->
      <!--</div>-->

      <div style="background-color: gainsboro; height: 1px;"></div>
    </div>
</template>

<script>
    export default {
        name: "myInformation",
      data () {
          return {
            openID: this.$store.getters.getUserInfo.openID,
            userID: this.$store.getters.getUserInfo.userID,
            nickname: this.$store.getters.getUserInfo.nickname,
            phone: "",
            name: this.$store.getters.getUserInfo.name,
            headImageUrl: this.$store.getters.getUserInfo.headImageUrl,
            phonecheck: true,
            check: true
        }
      },
      methods: {
        xx () {
          let params = {
            openID: this.$store.getters.getUserInfo.openID
          }
          this.$http.sendTemplate(params).then((response) => {
          })
        },
        aa () {
          let params = {
            openid: "456156789",
            token: "45678941"
          }
          this.$http.aa(params).then((response) => {
          })
        },
        jiaoFei () {
          this.$router.push({name: 'myCharge'})
        },
        fangChan () {
          this.$router.push({name: 'houseProperty'})
        },
        updatePhone () {
          this.check = false
          this.$store.commit("setPhoneInfo", {})
          this.$router.push({name: 'updatePhone'})
        },
        phoneHandle () {
          var phones = this.$store.getters.getUserInfo.phone
          phones = phones.replace(/(\d{3})\d{5}(\d{3})/, "$1*****$2");
          this.phone = phones
        }
      },
      beforeRouteLeave (to, from, next) {
        let toName = to.name
        if ((toName === "updatePhone" && this.check) || toName === "check") {
          localStorage.clear()
          window.WeixinJSBridge.call('closeWindow')
        } else {
          next()
        }
      },
      mounted () {
        // this.$store.commit("setUserInfo",{"phone":"13840953020"})
        this.phoneHandle()
      }
    }
</script>

<style scoped>
  .div1{
    height: 20vh;
  }
  .touxiang{
    height: 60%;
    border-radius: 60px;
    margin-top: 17px;
    margin-left: 10%;
  }
  .span1{
    position: absolute;
    top: 5%;
    left: 45%;
  }
  .shouji{
    position: absolute;
    top:11%;
    left: 44%;
  }
  .number{
    position: absolute;
    top: 12%;
    left: 50%;
  }
  .xiugai{
    position: absolute;
    top: 11%;
    left: 77%;
  }
  .daohang{
    /*margin-left: 15%;*/
    position: relative;
    top: -13%;
    left: 3%;
  }
  .dhciv{
    height: 50px;
    border: 4px;
    border-color: gainsboro white white;
    margin-top: 3%;
  }
  .tishi{
    margin-top: 2.5%;
    margin-left: 10%
  }
  .jiantou{
    position: relative;
    top: -6%;
    left: 52%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/myInformation.vue